import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import LayoutMUI from "./Layout";
import { AppContext } from "../utilities/context";
import Typography from "@mui/material/Typography";

axios.defaults.withCredentials = true;

const ForgotPassword = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState([
        {
          label: intl.formatMessage({ id: "app.header.home.label" }),
          url: "/",
        },
        {
          label: intl.formatMessage({ id: "app.header.login.label" }),
          url: "/login",
        },
      ]);
    }
  }, []);

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post("/api/forgot-password", { email })
      .then((response) => {
        if (response.data.success) {
          setMessage(
            intl.formatMessage(
              { id: "app.recovery.email.sent" },
              {
                defaultMessage:
                  "Se ha enviado un correo con instrucciones para restablecer tu contraseña",
              }
            )
          );
          setStatus("success");
        } else {
          setMessage(response.data.message);
          setStatus("error");
        }
      })
      .catch((error) => {
        console.log("forgot password error: ", error);
        setMessage(
          intl.formatMessage(
            { id: "app.recovery.error" },
            { defaultMessage: "Ocurrió un error al procesar tu solicitud" }
          )
        );
        setStatus("error");
      });
  };

  return (
    <LayoutMUI>
      <form>
        <Grid
          container
          direction={"column"}
          spacing={2}
          className={"forgotPasswordContainer"}
        >
          {message && (
            <Grid item>
              <Alert severity={status}>{message}</Alert>
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography variant="h6" component="div">
              <FormattedMessage
                id="app.terms.title.pp"
                defaultMessage={"Olvide mi contraseña"}
              />
            </Typography>
          </Grid>
          <Grid item>
            <FormControl fullWidth>
              <TextField
                id="email"
                name="email"
                value={email}
                onChange={handleChange}
                placeholder={intl.formatMessage({ id: "word.email" })}
              />
            </FormControl>
          </Grid>
          <Grid item>
            <Stack direction="row" spacing={2}>
              <Button
                onClick={handleSubmit}
                type={"submit"}
                variant={"contained"}
                color={"primary"}
              >
                <FormattedMessage
                  id="app.recovery.submit"
                  defaultMessage="Enviar correo de recuperación"
                />
              </Button>
              {/* <Button
                component={Link}
                to={"/login"}
                variant="outlined"
                color="primary"
              >
                <FormattedMessage
                  id="app.login.return"
                  defaultMessage="Volver al inicio de sesión"
                />
              </Button> */}
            </Stack>
          </Grid>
        </Grid>
      </form>
    </LayoutMUI>
  );
};

export default ForgotPassword;
